import { Controller } from "@hotwired/stimulus"
import { Autocomplete } from "stimulus-autocomplete"

// Connects to data-controller="linked-autocomplete"
export default class extends Controller {
  static targets = ["codeStudyInput", "codeStudyHidden", "codeStudyResults",
                    "studyInput", "studyHidden", "studyResults"]

  static values = {
    url: String,
    modality: String
  }

  connect() {
    this.setupAutocomplete("code-study")
    this.setupAutocomplete("study")
  }

  setupAutocomplete(field) {
    const inputTarget = field === "code-study" ? this.codeStudyInputTarget : this.studyInputTarget
    const resultsTarget = field === "code-study" ? this.codeStudyResultsTarget : this.studyResultsTarget

    inputTarget.addEventListener("input", (e) => this.handleInput(e, field))
    resultsTarget.addEventListener("click", (e) => this.handleSelect(e, field))
  }

  handleInput = (event, field) => {
    const query = event.target.value
    if (query.length < 1) {
      const resultsTarget = field === "code-study" ? this.codeStudyResultsTarget : this.studyResultsTarget
      resultsTarget.innerHTML = ""
      resultsTarget.classList.add("d-none")
      return
    }

    const params = new URLSearchParams()
    params.append('q', query)
    if (this.hasModalityValue) {
      params.append('modality', this.modalityValue)
    }

    fetch(`${this.urlValue}?${params.toString()}`)
      .then(response => response.text())
      .then(html => {
        const resultsTarget = field === "code-study" ? this.codeStudyResultsTarget : this.studyResultsTarget
        resultsTarget.innerHTML = html
        resultsTarget.classList.remove("d-none")
      })
      .catch(error => console.error("Error:", error))
  }

  handleSelect = (event, field) => {
    const option = event.target.closest("li[data-autocomplete-value]")
    if (!option) return

    event.preventDefault()
    event.stopPropagation()

    const codigoValue = option.getAttribute("data-codigo-value")
    const estudioValue = option.getAttribute("data-estudio-value")

    if (field === "code-study") {
      this.codeStudyInputTarget.value = codigoValue
      this.codeStudyHiddenTarget.value = codigoValue
      this.studyInputTarget.value = estudioValue
      this.studyHiddenTarget.value = estudioValue
    } else {
      this.studyInputTarget.value = estudioValue
      this.studyHiddenTarget.value = estudioValue
      this.codeStudyInputTarget.value = codigoValue
      this.codeStudyHiddenTarget.value = codigoValue
    }

    this.codeStudyResultsTarget.classList.add("d-none")
    this.studyResultsTarget.classList.add("d-none")
    this.codeStudyResultsTarget.innerHTML = ""
    this.studyResultsTarget.innerHTML = ""
  }
}
